import {
    EVENTS_VOLUME_PP,
    EVENT_ATTENDEES_PP,
    EVENT_CATEGORY,
    EVENT_VERTICAL,
    QUESTION_OPTIONS,
} from './constants';

export interface step {
    id: number;
    name: string;
    options: stepOption[];
}

export interface stepOption {
    value: number;
    name: string;
    heapName?: string;
}

interface OptionsMap {
    [value: number]: {
        name: string;
    };
}
export interface StepsMap {
    [stepName: string]: {
        id: number;
        options: OptionsMap;
    };
}

const optionsReducer = (options: stepOption[]): OptionsMap => {
    return options.reduce((optionsMap: OptionsMap, option) => {
        optionsMap[option.value] = {
            name: option.name,
        };
        return optionsMap;
    }, {});
};

export const getStepsMap = (): StepsMap => {
    const steps = STEPS_QUESTIONNAIRE;

    const stepsReduced = steps.reduce((stepsMap: StepsMap, step: step) => {
        stepsMap[step.name] = {
            id: step.id,
            options: optionsReducer(step.options),
        };
        return stepsMap;
    }, {});

    return stepsReduced;
};

export const STEPS_QUESTIONNAIRE: step[] = [
    {
        id: 14,
        name: EVENTS_VOLUME_PP,
        options: QUESTION_OPTIONS['SALES'],
    },
    {
        id: 15,
        name: EVENT_ATTENDEES_PP,
        options: QUESTION_OPTIONS['VISITORS'],
    },
    {
        id: 16,
        name: EVENT_CATEGORY,
        options: QUESTION_OPTIONS['CATEGORY'],
    },
    {
        id: 17,
        name: EVENT_VERTICAL,
        options: QUESTION_OPTIONS['VERTICAL'],
    },
];
